import React from 'react';
import Clock from '../../../../../assets/icons/Clock.svg';
import file from '../../../../../assets/icons/file.svg';
import user from '../../../../../assets/icons/user.svg';
import page from '../../../../../assets/icons/page.svg';
import payment from '../../../../../assets/icons/payment.svg';
import report from '../../../../../assets/icons/report.svg';
import HelpSection from './Components/HelpSection';

export const HelpSectionView = () => {
  const helps = [
    {
      cover: Clock,
      title: 'Individual Scheduling',
      desc: 'Quickly share your availability and let others book time with you—simple, fast, and stress-free.',
    },
    {
      cover: file,
      title: 'Auto-Assigned Meetings',
      desc: 'Let MeetOcto automatically assign meetings based on availability—no more guessing or double-booking. Everyone gets the right time, effortlessly.',
    },
    {
      cover: user,
      title: 'Team Member Selection',
      desc: 'Easily pick the right team members for each meeting. MeetOcto makes sure the right people are in the loop, every time.',
    },
    {
      cover: page,
      title: 'Team-Wide Pages',
      desc: 'Keep everyone on the same page with shared schedules and team info—all in one easy-to-access spot.',
    },
    {
      cover: payment,
      title: 'Centralized Billing',
      desc: 'Manage all your team’s payments in one place—simple, clear, and hassle-free.',
    },
    {
      cover: report,
      title: 'Metrics & Reporting',
      desc: 'Get a clear view of your meetings and team performance with easy-to-read reports—no spreadsheets required.',
    },
  ];

  return (
    <div>
      <div className="help-center wrapper">
        <div className="heading">Meetocto Can Help You</div>
        <div className="row helps">
          <h1>For Teams</h1>
            {helps.map((item, index) => (
              <HelpSection key={index} data={item} />
            ))}
        </div>
      </div>
    </div>
  );
};
